/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { RoleBadgesModule } from '../types'

const deploymentRoleBadgesModule: RoleBadgesModule<'deployment'> = {
  allInstancesRoleBadgeTooltipMessages: {
    id: 'role-badges.tooltip.all-hosted-deployments',
    defaultMessage: 'This role applies to all current and future hosted deployments.',
  },
  specificInstancesRoleBadgeTooltipMessages: {
    id: 'role-badges.tooltip.deployment',
    defaultMessage:
      'This role applies to {count} hosted {count, plural, one {deployment} other {deployments}}.',
  },
  customRoleBadgeTooltipMessages: {
    id: 'custom-role-badges.tooltip.deployment',
    defaultMessage:
      'This role applies to {count} hosted {count, plural, one {deployment} other {deployments}}.',
  },
  type: 'deployment',
}

export default deploymentRoleBadgesModule
